<template>
  <section v-if="!loading">
    <!-- Options selector -->
    <!-- <form>
      <label class="container-radio">
        <span
          class="radio-input checkmark"
          :class="{
            checked: clientSelected === true && othersSelected === true
          }"
          @click="selectOption('ALL')"
        >
          <input
            type="radio"
            name="addNew"
            value="other"
            :checked="clientSelected === false"
          /> </span
        >All
      </label>
      <label class="container-radio">
        <span
          class="radio-input checkmark"
          @click="selectOption('CLIENT')"
          :class="{
            checked: clientSelected === true && othersSelected === false
          }"
        >
          <input
            type="radio"
            name="addNew"
            value="client"
            :checked="clientSelected === true"
          /> </span
        >Client
      </label>
      <label class="container-radio">
        <span
          class="radio-input checkmark"
          @click="selectOption('OTHER')"
          :class="{
            checked: clientSelected === false && othersSelected === true
          }"
        >
          <input
            type="radio"
            name="addNew"
            value="other"
            :checked="clientSelected === false"
          /> </span
        >Other
      </label>
    </form> -->

    <!-- List -->
    <div class="phone-list-wrapper">
      <transition name="fade-full" appear mode="out-in">
        <ul v-if="displayList && displayList.length > 1" key="1">
          <template>
            <client-detail
              v-for="client in displayList"
              :chat-or-phone="chatOrPhone"
              :key="client.type + client.id"
              :client="client"
            />
          </template>
        </ul>
        <ul v-else>
          <li>Nothing to show</li>
        </ul>
      </transition>
    </div>
  </section>
  <div class="loader-container" v-else>
    <loader-vue />
  </div>
</template>

<script>
import LoaderVue from "../Appointment/common/Loader";
import ClientDetail from "./ClientDetail";
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    clients: [Array, Boolean], // List of all the clients
    people: [Array, Boolean], // List of all others
    users: [Array, Boolean], // List of all others
    groups: [Array, Boolean], // List of all others
    others: [Array, Boolean], // List of all others
    all: [Array, Boolean], // List of all
    chatOrPhone: String, // Chat or Phone
    show: String // Which list to show
  },
  computed: {
    ...mapGetters({
      loading: "getIsLoadingAddAppointment" // Should loading screen be shown
    }),
    displayList() {
      switch (this.show) {
        case "all":
          return this.all;

        case "client":
          return this.clients;

        case "person":
          return this.people;

        case "group":
          return this.groups;

        case "user":
          return this.users;

        default:
          return false;
      }
    }
  },
  components: {
    LoaderVue,
    ClientDetail
  },
  methods: {
    ...mapActions({
      getFormDetails: "getFormDetails" // Get form details from the server
    })
  },
  created() {
    this.getFormDetails();
  }
};
</script>

<style scoped>
form {
  padding: 15px;
  border-bottom: 1px solid #5888c5;
}

section >>> .star-wrapper img {
  width: 20px;
}

/*phone wrapper list css here */
section >>> .phone-list-wrapper {
  padding: 20px 15px;
}

section >>> .phone-list-wrapper ul {
  list-style: none;
  padding-left: 0px;
  margin: 0px;
}

section >>> .phone-list-wrapper ul li {
  border-bottom: 1px solid #ccc;
  padding: 10px 0px 13px 30px;
  display: flex;
  align-items: center;
  position: relative;
}

section >>> .phone-list-wrapper ul li span {
  margin-right: 10px;
  flex: 1;
}

section >>> .phone-list-wrapper ul li span.star-wrapper {
  position: absolute;
  left: 0;
}

section >>> .phone-list-wrapper ul li span:last-of-type {
  margin-right: 0px;
}

section >>> .call-wrapper a {
  padding: 5px 12px;
  background-color: #d26d13;
  color: #fff;
  display: inline-block;
}

.fade-full-enter {
  opacity: 0;
}

/* stage 2. Entered */
.fade-full-enter-active {
  transition: opacity 0.1s ease-in-out;
}

/* stage 3. leave */
.fade-full-leave-active {
  opacity: 0;
  transition: opacity 0.1s ease-in-out;
}
section
  >>> .phone-list-wrapper
  ul
  li
  span.dropdown-wrapper
  .add-phone::placeholder {
  color: rgb(210, 109, 19);
  text-align: right;
}
section >>> .phone-list-wrapper ul li span.dropdown-wrapper .add-phone {
  width: 100%;
  margin-bottom: 0px;
}
@media (min-width: 1080px) {
  section >>> .phone-list-wrapper ul li span.user-name-wrapper {
    max-width: 500px;
    width: 100%;
    flex: 0 0 500px;
  }
}
@media (max-width: 350px) {
  section >>> .phone-list-wrapper {
    padding-right: 10px;
  }
}
@media (max-width: 500px) {
  section >>> .phone-list-wrapper ul li span.user-name-wrapper {
    max-width: calc(100% - 203px);
    flex: calc(100% - 203px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 5px;
  }
  section >>> .phone-list-wrapper ul li span.user-name-wrapper.chat {
    max-width: calc(100% - 60px);
    flex: calc(100% - 60px);
    line-height: 22px;
  }
  section >>> .phone-list-wrapper ul li span.dropdown-wrapper {
    margin-right: 5px;
    max-width: 144px;
    flex: 144px;
  }
  section >>> .phone-list-wrapper ul li span.dropdown-wrapper .add-phone {
    margin-bottom: 0px;
    width: 100%;
  }
  section >>> .phone-list-wrapper ul li span.dropdown-wrapper .img-plus {
    margin-left: 5px;
  }
  /*--section >>> .phone-list-wrapper ul li span.call-wrapper {
    max-width: 38px;
    flex: 38px;
  }--*/
  section >>> .phone-list-wrapper ul li span.dropdown-wrapper.add-phone {
    max-width: 60%;
    flex: 60%;
    margin-bottom: 0px;
  }
}
</style>
